export const siteSettings = {
  name: "Smart Trade FX Pro",
  link: "https://smartradepro.net",
  email: "support@smartradepro.net",
  appLink: "https://app.smartradepro.net",
};
